/**
 * The admin app's one keyboard shortcut: ⌘K on Apple keyboards, Ctrl+K everywhere else,
 * which opens search. Every other ⌘-letter already belongs to the browser.
 */

/** iPadOS Safari reports itself as a Mac, which is right: its keyboards say ⌘ too. */
export function isApplePlatform(
  userAgent: string = typeof navigator === 'undefined' ? '' : navigator.userAgent,
): boolean {
  return /Mac|iPhone|iPad|iPod/.test(userAgent);
}

export function searchShortcutLabel(apple: boolean = isApplePlatform()): string {
  return apple ? '⌘K' : 'Ctrl K';
}

type ShortcutKeyEvent = Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'isComposing'>;

/**
 * Only the platform's own modifier counts. Ctrl+K on a Mac is "delete to end of line" in
 * every text field, and an admin who uses it should not have search open over their typing.
 */
export function isSearchShortcut(e: ShortcutKeyEvent, apple: boolean = isApplePlatform()): boolean {
  if (e.isComposing || e.shiftKey || e.altKey) return false;
  const modifier = apple ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
  return modifier && e.key.toLowerCase() === 'k';
}
